import * as React from 'react';
import { ArticleParagraph1 } from '@cian/ui-kit';
import { Tabs, ITabProps } from '@cian/ui-kit/prev';
import { Layout } from '../Layout';
import * as styles from './Commercial.css';

interface ICommercialProps {
  title: React.ReactNode;
  description: React.ReactNode;
  tabs: ITabProps[];
  activeTab: string;
  onTabChange: (newTab: string) => void;
  tabContent: React.ReactElement;
}

export function Commercial({ title, description, tabs, activeTab, onTabChange, tabContent }: ICommercialProps) {
  return (
    <section className={styles['commercial']}>
      <Layout>
        <div className={styles['commercial__wrapper']}>
          <div className={styles['top']}>
            <div className={styles['top__part']}>{title}</div>
            <div className={styles['top__part']}>
              <ArticleParagraph1 as="div">{description}</ArticleParagraph1>
            </div>
          </div>

          <div className={styles['tabs']}>
            <Tabs tabs={tabs} onChange={onTabChange} activeTab={activeTab} />
          </div>

          {tabContent}
        </div>
      </Layout>
    </section>
  );
}
